// src/constants/index.ts
var COPILOT_CLOUD_API_URL = "https://api.copilotkit.ai";
var COPILOT_CLOUD_VERSION = "v1";
var COPILOT_CLOUD_CHAT_URL = `${COPILOT_CLOUD_API_URL}/copilotkit/${COPILOT_CLOUD_VERSION}`;
var COPILOT_CLOUD_PUBLIC_API_KEY_HEADER = "X-CopilotCloud-Public-Api-Key";

export {
  COPILOT_CLOUD_API_URL,
  COPILOT_CLOUD_VERSION,
  COPILOT_CLOUD_CHAT_URL,
  COPILOT_CLOUD_PUBLIC_API_KEY_HEADER
};
//# sourceMappingURL=chunk-3AJ2GKWG.mjs.map